
import { OLMSApiService } from '@/shared/apis'
import { RootState } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

export type RemoveBreakPayload = {
  shiftId: EntityId
  stopId: EntityId | null
}

export const removeBreak = createAsyncThunk<void, RemoveBreakPayload, { state: RootState }>(
  'shiftTable/removeBreak',
  async ({ shiftId, stopId }, { getState }) => {
    const state = getState()
    const currentScreen = state.userInterface.currentScreen
    const endpoint = currentScreen === 'planning' ? '/planning/removeBreak' : '/runsheet/removeBreak'

    await OLMSApiService.post<null>(endpoint, {
      shiftId: shiftId,
      stopId: stopId,
    })
  },
)
